(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lsb-related"] && !Shopify.designMode) return;
  try {
    (() => {
    const TAG = 'lbs-related-quick-add';

    if (customElements.get(TAG)) return;

    class LbsRelatedQuickAdd extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.onChange = (event) => {
          const select = event.target.closest?.('[data-variant-select]');
          if (!select || !this.contains(select)) return;

          const card = select.closest('[data-product-card]');
          if (!card) return;

          const selected = select.selectedOptions?.[0];
          if (!selected) return;

          this.applyVariant(card, {
            id: selected.value,
            available: selected.dataset.available === 'true',
            price: selected.dataset.price || '',
            title: selected.dataset.title || selected.textContent.trim(),
            image: selected.dataset.image || '',
          });
        };

        this.onChoiceClick = (event) => {
          const choice = event.target.closest?.('[data-variant-choice]');
          if (!choice || !this.contains(choice)) return;

          const card = choice.closest('[data-product-card]');
          if (!card) return;

          const choices = card.querySelectorAll('[data-variant-choice]');

          for (const item of choices) {
            item.classList.toggle('is-selected', item === choice);
            item.setAttribute('aria-pressed', item === choice ? 'true' : 'false');
          }

          this.applyVariant(card, {
            id: choice.dataset.variantId || '',
            available: choice.dataset.available === 'true',
            price: choice.dataset.price || '',
            title: choice.dataset.title || '',
            image: choice.dataset.image || '',
          });
        };

        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onChoiceClick);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onChoiceClick);
      }

      applyVariant(card, variant) {
        const input = card.querySelector('[data-variant-input]');
        const addButton = card.querySelector('.lbs-related__add-button');
        const price = card.querySelector('[data-price-target]');
        const selectedValue = card.querySelector('[data-selected-value]');
        const image = card.querySelector('.lbs-related__image');

        if (input) {
          input.value = variant.id;
          input.disabled = !variant.available;
        }

        if (addButton) {
          addButton.disabled = !variant.available;
        }

        if (price && variant.price) {
          price.textContent = variant.price;
        }

        if (selectedValue && variant.title) {
          selectedValue.textContent = variant.title;
        }

        if (this.dataset.updateImage === 'true' && image && variant.image) {
          image.src = variant.image;
          image.removeAttribute('srcset');
        }
      }
    }

    customElements.define(TAG, LbsRelatedQuickAdd);
  })();
  } catch(e) { console.error(e); }
})();

})();
